import styled from "styled-components";
import { ButtonBackgroundColorType } from "./Button";
import { devices } from "../../ExternFormEnrollment.styles";

const getHoverBackground = (backgroundType: ButtonBackgroundColorType, isChecked: boolean) => {
  switch (backgroundType) {
    case ButtonBackgroundColorType.Blue:
      if(isChecked) {
        return `
          background-color: var(--color-blue-700);
        `;
      } else {
        return `
          background-color: var(--color-blue-50);
        `;
      }
    case ButtonBackgroundColorType.Grey:
      return `
            Background-color: #ccc; 
            `;
    case ButtonBackgroundColorType.Orange:
      return `
            background-color: var(--color-orange-700);
            `;
    case ButtonBackgroundColorType.Transparent:
      return `
            color: var(--color-blue-700);
            `;
  }
};

export const ButtonWrapper = styled.button<{backgroundType: ButtonBackgroundColorType; blockButton: Boolean; isChecked: boolean; bgColor: string; color: string; borderRadius: string; borderStyle: string; hoverOutline: string;}>`
  width: 100%;
  min-height: 50px;
  border: ${({ borderStyle }) => borderStyle};
  border-radius: ${({ borderRadius }) => borderRadius};
  background: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color};
  margin: 8px 0px 0px 0px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  text-decoration: ${({ backgroundType }) => (backgroundType === ButtonBackgroundColorType.Transparent ? "underline" : "none")};
  &:disabled {
    cursor: default;
  }
  &:hover {
    ${({ backgroundType, isChecked}) => getHoverBackground(backgroundType, isChecked)}
    outline: ${({ hoverOutline }) => hoverOutline};
  }

  ${(p) => p.isChecked && `background: var(--color-blue-700);`}
  ${(p) => p.isChecked && `color: #fff;`}
  ${(p) => p.blockButton && `flex: 1`}
`;

export const Spinner = styled.img`
  width: 18px;
  height: 18px;
  display: inline-block;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
